<template>
  <v-card class="mx-auto base-accodion" max-width="700px" elevation="0">
    <div class="title" @click="toggle">
      <v-img
        height="60px"
        width="200"
        :src="require(`@/assets/img/product/sees/${title.imgName}`)"
      ></v-img>
      <br />
      <v-card-subtitle> {{ title.title }}</v-card-subtitle>
    </div>
    <Transition
      name="accordion"
      appear
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <v-card-text v-show="currentAccordion" class="content"
        ><div id="reference_cardlist">
          <ul>
            <li v-for="pjt in title.project" :key="pjt">{{ pjt }}</li>
          </ul>
        </div>
      </v-card-text>
    </Transition>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: JSON,
    },
  },
  data() {
    return { currentAccordion: this.title.visible };
  },
  methods: {
    toggle() {
      this.currentAccordion = !this.currentAccordion;
    },
    beforeEnter(el) {
      el.style.height = '0';
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave(el) {
      el.style.height = '0';
    },
  },
  mounted() {
    //console.log(this.title);
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/seesJobmind';
.base-accodion {
  .title {
    padding: 20px;
    border-bottom: 1ps solid #ddd;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
     display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .content {
    overflow: hidden;
    padding: 20px;
    background-color: #f5f5f5;
  }
}
.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
div {
  white-space: pre-wrap;
}
</style>
